import { Meteor } from 'meteor/meteor';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { Mongo } from 'meteor/mongo';
import { Reservations } from '../reservations/reservations';
import { GroupBillsPayments } from './group-bills-payments';
import { Payments } from '../reservations/payments';
import _ from 'lodash';
import moment from 'moment';
import { HTTP } from 'meteor/http';
import { Email } from 'meteor/email';


export const GroupBills = new Mongo.Collection('group_bills');

GroupBills.allow({
	insert() { return true; },
	update() { return true; },
	remove() { return true; },
});

export const GroupBill = new SimpleSchema({
	id_facture: {
		type: String,
		label: "N° Facture",
		optional: true,
	},
    reservations: {
    	type: [String],
    	label: "reservations",
    },
    partnerId: {
    	type: String,
    	label: "Partenaire cible"
    },
		month: {
			type: String,
			label: "Partenaire cible",
			optional: true
		},
		price: {
			type: String,
			label: "prix",
			optional: true
		},
		solde: {
			type: String,
			label: "Solde restant",
			optional: true,
		},
    createdAt: {
        type: Date,
        label: "Date de création"
    },
    editedAt: {
        type: Date,
        label: "Dernière modification",
        autoValue: function() {
          return new Date();
        }
    }
  });

GroupBills.attachSchema(GroupBill);

// Dbs methods :

Meteor.methods({
  'groupBills.insert'(data) {

		console.log('month bill', data.month);

		let startDate = moment().startOf('year').toDate();
		let endDate = moment().endOf('year').toDate();

		console.log(startDate);
		console.log(endDate);

    let reservations = Reservations.find({userId: data.partnerId, groupBill: null, createdAt: {$gte: startDate, $lte: endDate}}).fetch();
    let reservationsIds = [];

		if(!reservations.length > 0) {
			console.log('Rien a facturer !');
			return false;
		}

		console.log(reservations.length + ' reservation(s) a facturer !');

		let totalPrice = 0;

    _.each(reservations, function(reservation) {
    	Reservations.update(reservation._id, {$set: {groupBill: true, state: 5}});
    	reservationsIds.push(reservation._id);
			totalPrice += reservation.getPrice();
    });

		let d = new Date();
		let total = parseInt(GroupBills.find({id_facture: {$regex: ".*" + d.getFullYear().toString().slice(-2) + "-.*"}}).fetch().length) + 1;

		let numerotation = '';
		for(let i = 0; i < (4 - total.toString().length); i++) {
			numerotation += '0';
		}

		let groupBillId = GroupBills.insert({
			'id_facture': 'G-' + d.getFullYear().toString().slice(-2) + '-' + numerotation + total,
			'reservations': reservationsIds,
			'partnerId': data.partnerId,
			'createdAt': new Date(),
			'month': data.month,
			'price': totalPrice,
			'solde': totalPrice
		}, function(err, _id) {

			console.log('creation du paiement ...', _id);
			let bill = GroupBills.findOne(_id);
			// création du paiement indépendant :
			_.each(reservations, function(reservation) {
				let payment = {
					'type': 'Facture groupée',
					'montant': reservation.getPrice(),
					'informations': 'Facture partenaire n°' + bill.id_facture,
					'reservation': reservation._id
				};

				Payments.insert(payment);
		    //data.groupBill.month = moment(data.groupBill.month).format('MMM YYYY');
			});

			let data = {
				'groupBill': bill,
				'reservations': bill.getReservations(),
				'partner': bill.getPartner()
			};

			HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=groupFacture', {
				data
			}, (error, result) => {
				result = JSON.parse(result.content);

				console.log('PDF créé !');
				let invoice = "https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf";

				Email.send({
					to: 'facture@montgolfieres.fr',
					from: 'anjou@montgolfieres.fr',
					subject: 'Facture partenaire',
					html: 'Télécharger : ' + invoice
				});
			});
		});
  }
});

GroupBills.helpers({
	getPartner() {
		// Meteor.subscribe('users');
		return Meteor.users.findOne(this.partnerId);
	},
	getReservations() {
		let reservations = [];

		_.each(this.reservations, (id) => {
			let reservation = Reservations.findOne(id);
			if(reservation) {
					reservation.flight = reservation.getFlightType();
					reservation.price = reservation.getPrice();
					reservations.push(reservation);
			}
		});

		return reservations;
	},
	getSolde() {
		let payments = GroupBillsPayments.find({bill: this._id}).fetch();
		let solde = 0;

		_.each(this.getReservations(), (reservation) => {
			solde += reservation.getPrice();

			if(this.price != solde) {
				GroupBills.update(this._id, {'$set': {price: solde}});
			}
		});

		_.map(payments, function(payment) { solde -= payment.montant; });

		if(solde != this.solde) {
			GroupBills.update(this._id, {'$set': {solde: solde}});
		}

		return solde;
	},
});



/** WEBPACK FOOTER **
 ** ./src/universal/collections/partners/group-bills.js
 **/